module.exports = __webpack_public_path__ + "img/brocha.341d499d.svg";